import React, {forwardRef, useEffect, useImperativeHandle} from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';
import CloseIcon from '../icons/Close.icon';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const Modal = forwardRef(({show = false, ...props}, ref) => {
  const [display, setDisplay] = React.useState(false);
  const {className, title, onClose} = props;

  useImperativeHandle(ref, () => {
    return {
      open: () => open(),
      close: () => close()
    }
  });

  const open = () => {
    setDisplay(true);
  };

  const close = () => {
    setDisplay(false);
  };

  useEffect(() => {
    setDisplay(show);
  }, [show, setDisplay])

  if (display) {
    return ReactDOM.createPortal(
      <React.Fragment>
        <div className={styles.modalOverlay}/>
        <div className={styles.modalWrapper} aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className={clsx(styles.modal, className)}>
            <div className={styles.modalHeader}>
              <h3 className="modal-title text-center">{title}</h3>
              <span className={clsx('btn btn-outline-light cursor-pointer')} data-dismiss="modal" aria-label="Close" onClick={onClose || close}>
                <CloseIcon className="inline-icon" stroke="white"/>
              </span>
            </div>

            <div className="m-4 modal-body overflow-auto">
              {props.children}
            </div>
          </div>
        </div>
      </React.Fragment>,
      document.getElementById('modal-root')
    )
  }

  return null;
});

Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func
};

export default Modal
